const getters = {
  getPrivileges: (state) => state.privileges,
  getPrivilege: (state) => state.privilege,
  getPermissions: (state) => state.permissions,
};

export default getters;
